import { Actions } from './pdaSettingsActions';
import { PDASettingsConstants } from './pdaSettingsConstants';
import { IPDASettingsState } from './pdaSettingsState';

export const initialState: IPDASettingsState = {
  isLoading: false,
  pdaSettingList: [],
  errorMessage: null,
};

export function pdaSettings(
  state: IPDASettingsState = initialState,
  action: Actions,
): IPDASettingsState {
  switch (action.type) {
    case PDASettingsConstants.GET_PDA_SETTINGS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case PDASettingsConstants.GET_PDA_SETTINGS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        pdaSettingList: action.payload,
      };
    case PDASettingsConstants.GET_PDA_SETTINGS_FAILURE: {
      return {
        ...state,
        isLoading: false,
        errorMessage: action.error.message,
      };
    }
    default:
      return state;
  }
}
